import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import {transactionsEdit_template} from "../components/templates/transactionsEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";


declare var ko: any;
declare var page: any;

export class transactions_edit extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: transactionsEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName() {
        return "transactions_edit";
    }

    buildContent() : Array<Element>{

        // create validation errors list template

        // create the transactions form
        this.editForm = new transactionsEdit_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Transaction Form");

        return [this.editForm.build()];
    }

    fillPage() : void{

        this.editForm.buildDatePickerCalendar();
        this.getFormData();
    }

    protected saveEditTransaction(){

        this.save();
    }
    public cancelForm() {
        this.cancelEditTransaction();
    }

    protected cancelEditTransaction(){


        this.releaseLock();

        let idBrand = this.getTransactionSystem();
        let url: string = '/brand/' + idBrand + '/payment/transactions/';
        if (idBrand == 'VN') {
            url = '/payment/transactions/';
        }

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Transaction action canceled!");

        let previousUrl = this.loadPreviousPage(window.location.href);
        if(previousUrl){
            page.redirect(previousUrl);
        }else{
            page.redirect(url);
        }
    }

    protected releaseLock(){


        let idBrand = this.getTransactionSystem();
        // request a lock release
        let usrReq_url: string = '/api/brand/' + idBrand + '/payment/transaction/release/lock_edit';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", this.getVnAppZone().app.params.id] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.execute();
    }

    //
    // obtain the dynamic data required to fill the form
    protected getFormData(){

        this.loadingIn(this.editForm.builtTemplate);

        let id: number;
        let action: string;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.viewModel["editForm"].id(id);
        }

        let usrReq_url: string;

        let idBrand = this.getTransactionSystem();
        usrReq_url = '/api/brand/' + idBrand + '/transaction/data/' + id;


        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(this.viewModel["editForm"])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    protected getTransactionSystem() {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        if (idBrand == undefined || idBrand == 'undefined') {
            idBrand = 'VN';
        }
        return idBrand;
    }

//
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let thisModule = (<transactions_edit>obj);
                let responseParsed = JSON.parse(req.request.response);

                let vnApp = thisModule.getVnAppZone().app;
                let data = responseParsed.data;

                if(data) {
                    let trx = data.transaction;
                    //let reverseTrx = data.reverseTransaction;
                    obj.editForm.setCurrencies(data.currencies);
                    let statuses = data.statuses;

                    if(!trx ) {
                        statuses = statuses.filter(function (obj) {
                            return obj.id == 1;
                        });
                    } else if(trx) {
                        statuses = statuses.filter(function (obj) {
                            return obj.id !== 2;
                        });
                    }
                    obj.editForm.setStatus(statuses);
                    obj.editForm.setCreationTypes(data.creationTypes);
                    obj.editForm.setActionTypes(data.actionTypes);
                    obj.editForm.setAllAccounts(data.accounts);
                    obj.editForm.setTypes(data.types);
                    obj.editForm.setEntryTypes(data.entryTypes);
                    obj.editForm.setAllEntryTypeOptions(data.entryTypes);
                    obj.editForm.setUsers(data.users);
                    obj.editForm.setArticles(data.articles);
                    obj.editForm.setChannels(data.channels);
                    obj.editForm.setRoles(data.roles);
                    obj.editForm.setArticleGroups(data.articleGroups);
                    obj.editForm.setCreator(data.creator);

                    if (obj.getTransactionSystem() == "VN") {
                        obj.editForm.setRequiresBrandSplit(true);
                        obj.editForm.setBrandOptions(data.brands);
                        obj.editForm.setAllBrands(data.brands);
                        obj.editForm.setValnetSupportSplit(data.valnetSupportSplit);
                    }

                    obj.editForm.setAllItemTypes(data.itemTypes);

                    if (trx && trx.id) {
                        obj.editForm.setTrxId(trx.id);
                        obj.editForm.setIsEdit(true);
                        obj.editForm.setSelectedUser(trx.idUser, trx.idItemType);
                        obj.editForm.setSelectedAccount(trx.idAccount);
                        obj.editForm.setSelectedActionType(trx.idActionType);
                        obj.editForm.setSelectedType(trx.idType);
                        obj.editForm.setSelectedCreationType(trx.idCreationType);
                        obj.editForm.setSelectedEntryType(trx.idEntryType);
                        obj.editForm.setSelectedRole(trx.idRole)
                        obj.editForm.setSelectedCurrency(trx.idCurrency);
                        obj.editForm.getTemplateViewModel().filterDate.singleDatePicker(trx.dateScheduled);

                        obj.editForm.getTemplateViewModel().amount(trx.amount);
                        obj.editForm.getTemplateViewModel().name(trx.name);
                        obj.editForm.getTemplateViewModel().note(trx.note);
                        if(trx.idItem) {
                            obj.editForm.setSelectedItem(trx.idItem);
                        }
                        obj.editForm.getTemplateViewModel().idItem(trx.idItem);

                        if (trx.idItemType == 6 || trx.idItemType == 11) {
                            obj.editForm.setTransactionPeriod(data.transactionPeriod);
                        }

                        if (trx.item != null) {
                        }
                        if (data.channel != null) {
                            obj.editForm.getTemplateViewModel().idChannel(data.channel.id);
                        }

                        if (trx.payment && trx.payment.datePaid) {
                            let reverseTrx = data.reverseTransaction;
                            obj.editForm.setSelectedPayment(trx.payment);
                            obj.editForm.setComparisonTransactions(trx, reverseTrx, data);
                            obj.editForm.showComparisonTrx();
                            obj.editForm.showReversalTrx();
                            obj.editForm.setIsPaid();
                            obj.editForm.setInfoTitle("New");
                            // obj.viewModel["editForm"].id("");
                        }
                        let idStatus = trx.idStatus;
                        if(idStatus == 2) {
                            idStatus = 1;
                        }
                        obj.editForm.setSelectedStatus(idStatus);

                        //add recurring if transaction is not recurring
                        if (trx.idItemType == 2) {
                            obj.editForm.setAllItemTypes(data.itemTypes);
                        }
                        obj.editForm.setSelectedItemType(trx.idItemType);

                        if(data.republishes){
                            obj.editForm.setRepublishArticle(data.articles);
                            obj.editForm.setArticleRepublishes(data.republishes);
                        }
                    } else {
                        obj.editForm.setAccounts(data.accounts);
                        obj.editForm.setSelectedStatus(1);
                        obj.editForm.setSelectedActionType(1);
                        obj.editForm.setSelectedCreationType(1);
                        obj.editForm.setSelectedType(2);
                        obj.editForm.setSelectedItemType(1);
                    }
                    obj.editForm.setEntryTypeRules(data.entryTypeRules)
                }

                obj.loadingOut(obj.editForm.builtTemplate);
            });
        }
    }

    protected save(){

        this.loadingIn(this.editForm.builtTemplate);

        //
        // get the short anem of the brand ot make the call to the API
        let transactionSystem = "VN";
        let vnApp = this.getVnAppZone().app;
        for ( let b of vnApp.loggedUser.user.brands ) {

            if( b.id == this.getVnAppZone().app.params.idBrand){

                transactionSystem = b.shortName;
            }
        }

        let _this = this;
        //
        // build ther ight url for the API call
        let formReq_url: string;
        formReq_url = '/api/' + transactionSystem + '/transactions/save/';


        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {
            id:  this.editForm.getTemplateViewModel().id(),
            amount: this.editForm.getTemplateViewModel().amount(),
            name: this.editForm.getTemplateViewModel().name(),
            note: this.editForm.getTemplateViewModel().note(),
            idStatus: this.editForm.getTemplateViewModel().idStatus(),
            idCurrency: this.editForm.getTemplateViewModel().idCurrency(),
            idActionType: this.editForm.getTemplateViewModel().idActionType(),
            idType: this.editForm.getTemplateViewModel().idType(),
            idCreationType: 1,
            idEntryType: this.editForm.getTemplateViewModel().idEntryType(),
            idItemType: this.editForm.getTemplateViewModel().idItemType(),
            idItem: this.editForm.getTemplateViewModel().idItem(),
            idRole: this.editForm.getTemplateViewModel().idRole(),
            idUser: this.editForm.getTemplateViewModel().idUser(),
            idAccount: this.editForm.getTemplateViewModel().idAccount(),
            filterDate: this.editForm.getTemplateViewModel().filterDate,
            comparisonTransactions: this.editForm.getTemplateViewModel().comparisonTransactions,
            brands: this.editForm.getTemplateViewModel().brands,
            transactionPeriod: this.editForm.getTransactionPeriod()
        };


        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function () {
                obj.manageResponse(req, obj, function () {
                    let transactionEditModule = (<transactions_edit>obj);
                    let responseParsed = JSON.parse(req.request.response);

                    let idBrand = obj.getTransactionSystem();
                    let url: string = '/brand/' + idBrand + '/payment/transactions/';
                    if (idBrand == 'VN') {
                        url = '/payment/transactions/';
                    }

                    obj.releaseLock();

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Transaction saved successfully!");
                    obj.editForm.validationsList.clearMessages();

                    let previousUrl = obj.loadPreviousPage(window.location.href);
                    if(previousUrl){
                        page.redirect(previousUrl);
                    }else{
                        page.redirect(url);
                    }

                    page.redirect(url);
                });
                obj.loadingOut(obj.editForm.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected getUsersSuggestion(keyword) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, from: 'transaction'};
        let idBrand = this.getTransactionSystem();
        let usrReq_url: string = '/api/brand/' + idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.users) {
                    obj.editForm.setUsers(responseParsed.data.users);
                }
            });
            obj.editForm.deactivateLoading();
        }
    }

    protected getArticlesSuggestion(keyword) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.articles) {
                    obj.editForm.setArticles(responseParsed.data.articles);
                }

            });

            obj.editForm.deactivateLoading();
        }
    }

    protected getOutreachArticlesSuggestion(keyword) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/outreach/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetOutreachArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetOutreachArticlesSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.articles) {
                    obj.editForm.setOutreachArticles(responseParsed.data.articles);
                }
            });

            obj.editForm.deactivateLoading();
        }
    }

    protected getArticleRepublishes(idArticle) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/article/" + idArticle + "/republishes/get/";
        let usrReq_params: Array<Array<string>> = [];
        // usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticleRepublishesReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticleRepublishesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.republishes) {
                    obj.editForm.setArticleRepublishes(responseParsed.data.republishes);
                }
            });

            obj.editForm.deactivateLoading();
        }
    }

    protected getSplitsByRevenue(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let transactionSystem = "VN";

        let subViewModel = {
            selectedPeriod: this.editForm.getPeriodForSplit(),
            transactionAmount: this.editForm.getTemplateViewModel().amount(),
            idTransaction: this.editForm.getTemplateViewModel().id(),
            idUser: this.editForm.getTemplateViewModel().idUser
        };

        let usrReq_url: string = '/api/brand/' + transactionSystem + "/transactions/getSplitsByRevenue/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetSplitsByRevenueReturn;
        this.XHRHdl.execute();
    }

    protected onGetSplitsByRevenueReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.editForm.setAllBrands(responseParsed.data);
                obj.editForm.setBrandOptions(responseParsed.data);
            });

            obj.editForm.deactivateLoading();
        }
    }


    public enableSplitButtonCall(enable: boolean): void {

        this.editForm.enableSplitButtonCall(enable);
    }
}



// WEBPACK FOOTER //
// ./js/modules/transactions_edit.ts